<template>
    <div class="main">
        <div class="head">
            <img src="../assets/images/tdyy1.jpg" alt="">
        </div>
        <div>
            <van-cell-group>
                <van-field label="单位名称" placeholder="请填写单位名称" v-model="NAME" />
                <van-field label="单位联系人" placeholder="请填写单位联系人" v-model="CONTACTS" />
                <van-field label="联系电话" placeholder="请填写联系电话" v-model="CONTACTS_PHONE" />
                <van-field label="体检人数" placeholder="请填写体检人数" v-model="PERSON_NUM" />
            </van-cell-group>
        </div>
        <div class="tcinfo">
            <h3>【预约说明】</h3>
            <ul>
                <li>1.请填写单位信息，我们会及时与您联系；</li>
                <li>2.请填写单位信息，我们会及时与您联系；</li>
                <li>3.请填写单位信息，我们会及时与您联系；</li>
                <li>4.请填写单位信息，我们会及时与您联系；</li>
                <li>5.请填写单位信息，我们会及时与您联系；</li>
            </ul>
        </div>
        <div>
            <!-- <button type="button" @click="home">取消</button> -->
            <button type="button" class="submit" @click="yycg">保存提交</button>
        </div>
    </div>
</template>

<script>
    import api from "@/fetch/api";
    import {
        mapGetters
    } from 'vuex';
    import {
        Toast
    } from 'vant';
    export default {
        data() {
            return {
                NAME: '',
                CONTACTS: '',
                CONTACTS_PHONE: '',
                PERSON_NUM: ''
            }
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo"]),
        },
        methods: {
            home() {
                this.$router.push({
                    path: '/home'
                });
            },
            yycg() {
                if (this.NAME.length == 0 || this.CONTACTS.length == 0 || this.CONTACTS_PHONE.length == 0 || this.PERSON_NUM.length == 0) {
                    Toast.fail('请务必将信息填写完整');
                    return false;
                }
                let params = {
                    NAME: this.NAME,
                    CONTACTS: this.CONTACTS,
                    CONTACTS_PHONE: this.CONTACTS_PHONE,
                    PERSON_NUM: this.PERSON_NUM
                };
                api.teamOrder(this.userInfo.CUSTOMER_ID, params).then(re => {
                    if (re.result == true) {
                        this.$router.push({
                            path: 'yycg'
                        });
                    }
                })
            }
        },
        created() {
            window.scroll(0, 0);
        }
    }
</script>

<style scoped lang='less'>
    body {
        background-color: #fff;
    }
    .main {
        font-size: 0.8rem;
        font-family: 'Arial Normal', 'Arial';
        font-weight: 400;
        font-style: normal;
        color: #797979;
        .head {
            // background: url(../assets/images/tdyy1.jpg);
            // min-height: 9em;
            // margin-bottom: 5px;
            // background-size: 100% 9em;
            // background-repeat: no-repeat;
            // zoom: 1;
            // position: relative;
            // margin: 0;
            img {
                width: 100%;
            }
        }
        >div {
            text-align: center; // margin: 0.3rem 0;
            input[type="text"] {
                width: 10rem;
                border-width: 1px;
                border-style: solid;
                border-color: rgba(228, 228, 228, 1);
                border-radius: 4px;
                height: 2em;
            }
        }
        >div:nth-child(2) {
            margin-top: 1em;
        }
        label {
            text-align: left;
            display: inline-block;
            width: 5rem;
        }
        pre {
            margin-top: 2rem;
            text-align: left;
        }
        button {
            background-color: rgba(255, 255, 255, 1);
            box-sizing: border-box;
            border-width: 1px;
            border-style: solid;
            border-color: #aacd06;
            border-radius: 5px;
            box-shadow: none;
            color: #aacd06;
            font-size: 0.9rem;
            width: 80%;
            height: 2.4rem;
            text-align: center;
            margin: 0 1rem;
        }
        button.submit {
            color: #ffffff;
            background-color: #aacd06;
        }
        .tcinfo {
            padding: 0.5em 1em;
            line-height: 2em;
            ul>li {
                text-indent: 2em;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/tdyy.vue